module.exports = __webpack_public_path__ + "img/easycard.f1ebfbd2.svg";